import HeaderCategoryView from "../view/header-category.js";
import HeaderCategoryModel from "../model/header-category.js";

import Animation from "../../animation/animation.js";

import {
  defaultHeaderCategoryModelData,
  ActionType,
  DEBOUNCE_TIME,
  ANIMATION_DURATION
} from "../const.js";

import {
  generateId
} from "../../../utils/generate-id.js";

import {
  debounce
} from "../../../utils/debounce.js";

export default class HeaderCategories {
  constructor(categories) {
    this._categories = categories;

    this._categoriesView = {};
    this._categoriesModel = {};

    this._isWindowListenerAdded = false;
    this._isDocumentListenerAdded = false;

    this._animation = new Animation();

    this._handleCategoryMouseEnter = this._handleCategoryMouseEnter.bind(this);
    this._handleChangeData = this._handleChangeData.bind(this);
    this._handleDocumentMouseOver = this._handleDocumentMouseOver.bind(this);
    this._handleCategoryButtonClick = this._handleCategoryButtonClick.bind(this);
    this._handleDocumentClick = this._handleDocumentClick.bind(this);

    this._debouncedHandlerDocumentMouseOver = debounce(this._handleDocumentMouseOver, DEBOUNCE_TIME);
  }

  init() {
    Array.from(this._categories).forEach((element) => {
      const id = generateId();
      this._addItem(element, id);
    });

    document.addEventListener(`mouseover`, this._debouncedHandlerDocumentMouseOver);
  }

  addCategory(element) {
    const id = generateId();
    this._addItem(element, id);

    return id;
  }

  removeCategory(id) {
    delete this._categoriesModel[id];
    delete this._categoriesView[id];
  }

  _addItem(element, id) {
    const categoryView = new HeaderCategoryView(element, id);
    categoryView.setMouseEnterHandler(this._handleCategoryMouseEnter);
    categoryView.setButtonClickHandler(this._handleCategoryButtonClick);

    this._categoriesView[id] = categoryView;

    const categoryModel = new HeaderCategoryModel(Object.assign(
        {},
        defaultHeaderCategoryModelData
    ));
    categoryModel.addObserver(this._handleChangeData);
    this._categoriesModel[id] = categoryModel;
  }

  _openSubList(id) {
    const categoryView = this._categoriesView[id];
    const subList = categoryView.getSubList();

    this._animation.fadeIn(
        subList,
        ANIMATION_DURATION
    );
  }

  _closeSubList(id) {
    const categoryView = this._categoriesView[id];
    const subList = categoryView.getSubList();

    this._animation.fadeOut(
      subList,
      ANIMATION_DURATION
    );
  }

  _processSubListClose(id) {
    const model = this._categoriesModel[id];
    const modelData = model.getData();

    if (modelData.isOpenedSubList) {
      model.changeData(Object.assign(
          {},
          modelData,
          {
            isOpenedSubList: false
          }
      ), ActionType.CLOSE_SUBLIST, {
        id
      });
    }
  }

  _processSubListOpen(id) {
    this._closeSubLists(id);

    const model = this._categoriesModel[id];
    const modelData = model.getData();

    model.changeData(Object.assign(
        {},
        modelData,
        {
          isOpenedSubList: true
        }
    ), ActionType.OPEN_SUBLIST, {
      id
    });
  }

  _closeSubLists(currentId) {
    const currentView = this._categoriesView[currentId];

    Object.entries(this._categoriesView)
      .forEach(([id, view]) => {
        if (currentId && +id === currentId) {
          return;
        }

        if (currentView) {
          const parent = view.getParentElement();

          if (parent.contains(currentView.getElement())) {
            return;
          }
        }

        this._processSubListClose(id);
      });
  }

  _isOverElements(target) {
    const elements = Object
      .values(this._categoriesView)
      .map((view) => view.getParentElement());

    return elements
      .some((element) => element.contains(target));
  }

  _handleCategoryButtonClick(id) {
    this._processSubListOpen(id);
  }

  _handleCategoryMouseEnter(id) {
    this._processSubListOpen(id);
  }

  _handleDocumentMouseOver(evt) {
    const target = evt.target;

    const overElements = this._isOverElements(target);

    if (!overElements) {
      this._closeSubLists();
      document.removeEventListener(`mouseover`, this._debouncedHandlerDocumentMouseOver);
      this._isWindowListenerAdded = false;
    }
  }

  _handleDocumentClick(evt) {
    const target = evt.target;
    const overElements = this._isOverElements(target);

    if (!overElements) {
      this._closeSubLists();
      document.removeEventListener(`click`, this._handleDocumentClick);
      this._isDocumentListenerAdded = false;
    }
  }

  _handleChangeData(action, payload) {
    switch (action) {
      case ActionType.OPEN_SUBLIST:
        this._openSubList(payload.id);

        if (!this._isWindowListenerAdded) {
          document.addEventListener(`mouseover`, this._debouncedHandlerDocumentMouseOver);
          this._isWindowListenerAdded = true;
        }

        if (!this._isDocumentListenerAdded) {
          document.addEventListener(`click`, this._handleDocumentClick);
          this._isDocumentListenerAdded = true;
        }
        break;
      case ActionType.CLOSE_SUBLIST:
        this._closeSubList(payload.id);
        break;
    }
  }
}
